export default __webpack_public_path__ + "0f725390037c91212bc87a891db6451a.svg";